"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HotDealsPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var selection_1 = require("../../reducers/slices/selection");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var main_1 = require("../../reducers/slices/main");
var products_list_1 = require("../../api/calls/product/products_list");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var favourite_product_1 = require("../../api/calls/product/favourite_product");
var get_favourite_ids_1 = require("../../api/calls/product/get_favourite_ids");
var add_to_basket_thunk_1 = require("../../reducers/slices/basket/thunks/add_to_basket_thunk");
var image_default_png_1 = __importDefault(require("../../assets/image_default.png"));
var google_tags_1 = require("../../constants/google_tags");
var HotDealsPage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, react_1.useState)([]), productsList = _a[0], setProductsList = _a[1];
    var _b = (0, react_1.useState)(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = (0, react_1.useState)(1), totalRecords = _c[0], setTotalRecords = _c[1];
    var _d = (0, react_1.useState)(10), recordsPerPage = _d[0], setRecordsPerPage = _d[1]; //Change this
    var _e = (0, react_1.useState)(1), currentPage = _e[0], setCurrentPage = _e[1];
    var _f = (0, react_1.useState)([]), favouriteIds = _f[0], setFavouriteIds = _f[1];
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    //Used to triger the useefect to reload data
    (0, react_1.useEffect)(function () {
        init();
    }, [user]);
    var init = function () {
        if (user === null || user === void 0 ? void 0 : user._id) {
            (0, get_favourite_ids_1.get_favourite_ids)().then(function (response) {
                if (response.success) {
                    setFavouriteIds(response.content);
                }
            });
        }
        else {
            setFavouriteIds(null);
        }
    };
    (0, react_1.useEffect)(function () {
        (0, products_list_1.get_tlc_product_list)({
            on_promotion: true,
            size: recordsPerPage.toString(),
            page: currentPage.toString(),
        }).then(function (data) {
            var _a, _b;
            if (data) {
                var mappedProducts = [];
                setTotalRecords((_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.count);
                var _loop_1 = function (product) {
                    mappedProducts.push({
                        _id: product === null || product === void 0 ? void 0 : product._id,
                        image: (product === null || product === void 0 ? void 0 : product.image_url) ? product === null || product === void 0 ? void 0 : product.image_url : image_default_png_1.default,
                        title: product === null || product === void 0 ? void 0 : product.title,
                        titleColor: "text-black",
                        amount: product === null || product === void 0 ? void 0 : product.price,
                        borderColor: "border-none",
                        amountColor: "text-secondary",
                        shadowColor: "shadow-shadows",
                        //rating: product?.rating?.average ?? 0,
                        discountLabel: (product === null || product === void 0 ? void 0 : product.on_promotion) ? "ON PROMOTION" : "",
                        discountAmount: (product === null || product === void 0 ? void 0 : product.on_promotion) ? product === null || product === void 0 ? void 0 : product.promotion_price : null,
                        quantity: product === null || product === void 0 ? void 0 : product.quantity,
                        pid: product === null || product === void 0 ? void 0 : product.pid,
                        status: product === null || product === void 0 ? void 0 : product.status,
                        sku: product === null || product === void 0 ? void 0 : product.sku,
                        sub_title: product === null || product === void 0 ? void 0 : product.sub_title,
                        description: product === null || product === void 0 ? void 0 : product.description,
                        instruction: product === null || product === void 0 ? void 0 : product.instruction,
                        estimated_delivery_time: product === null || product === void 0 ? void 0 : product.estimated_delivery_time,
                        promotion_price: product === null || product === void 0 ? void 0 : product.promotion_price.toString(),
                        on_promotion: product === null || product === void 0 ? void 0 : product.on_promotion,
                        extraText: product.estimated_delivery_time ? "Estimated Delivery: ".concat(product.estimated_delivery_time, " ") : "",
                        outOfStock: (product === null || product === void 0 ? void 0 : product.status) != "AVAILABLE" ? true : false,
                        colors: {
                            discount: {
                                textColor: "text-white",
                                amountColor: "text-red-500",
                                backgroundColor: "bg-red-500",
                            },
                            extraText: {
                                textColor: "text-success",
                            },
                            outOfStock: {
                                textColor: "text-white",
                                backgroundColor: "bg-gray-400",
                            },
                        },
                        favorite: {
                            icon: (favouriteIds === null || favouriteIds === void 0 ? void 0 : favouriteIds.find(function (x) { return x === product.pid; })) ? pro_solid_svg_icons_1.faHeart : pro_light_svg_icons_1.faHeart !== null && pro_light_svg_icons_1.faHeart !== void 0 ? pro_light_svg_icons_1.faHeart : pro_light_svg_icons_1.faHeart,
                            iconColor: "text-red-500",
                            onClick: function () {
                                var _a;
                                if (user._id) {
                                    (0, favourite_product_1.favorite_product)({
                                        product_id: product.pid,
                                        category_id: (_a = product === null || product === void 0 ? void 0 : product.category) === null || _a === void 0 ? void 0 : _a.integration_id,
                                        product_name: product.title,
                                    }).then(function (response) {
                                        if (response.success) {
                                            init();
                                            dispatch((0, main_1.setMessageModal)({
                                                title: "Success",
                                                messages: ["".concat(response === null || response === void 0 ? void 0 : response.message)],
                                            }));
                                        }
                                        else {
                                            dispatch((0, main_1.setMessageModal)({
                                                title: "Failed",
                                                messages: ["".concat(response === null || response === void 0 ? void 0 : response.message)],
                                            }));
                                        }
                                    });
                                }
                                else {
                                    dispatch((0, main_1.setDrawerPage)("login"));
                                    dispatch((0, main_1.setDrawerOpen)(true));
                                }
                            },
                        },
                    });
                };
                for (var _i = 0, _c = (_b = data === null || data === void 0 ? void 0 : data.content) !== null && _b !== void 0 ? _b : []; _i < _c.length; _i++) {
                    var product = _c[_i];
                    _loop_1(product);
                }
                setProductsList(mappedProducts);
                setIsLoading(false);
            }
        });
    }, [currentPage, favouriteIds]);
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null, isLoading ? (react_1.default.createElement(doshx_controls_web_1.ShimmerBoxControl, null)) : (react_1.default.createElement(doshx_controls_web_1.ProductsBigControl, { imageFit: "contain", category: {
                name: "Hot Deals",
                color: "text-black",
            }, products: productsList, onClick: function (product) {
                (0, google_tags_1.trackProductClick)({
                    products: [
                        {
                            title: product.title,
                            _id: product._id,
                            price: product.amount,
                            quantity: product.quantity,
                            sku: "",
                        },
                    ],
                    _id: product._id,
                    price: product.amount,
                });
                dispatch((0, selection_1.setSelectedProduct)(product));
                navigate("/product/".concat(product._id));
            }, canIncrement: true, button: {
                label: "Cart",
                borderColor: "border-primary",
                backgroundColor: "bg-primary",
                textColor: "text-white",
                onClick: function (product) {
                    dispatch((0, add_to_basket_thunk_1.add_product_thunk)(__assign({}, product)));
                },
            }, pagination: {
                currentPage: currentPage,
                totalRecords: totalRecords,
                recordsPerPage: recordsPerPage,
                onClick: function (pageNumber) {
                    setCurrentPage(pageNumber);
                },
            } })))));
};
exports.HotDealsPage = HotDealsPage;
